import { themeObjectToString } from '@atlaskit/tokens/theme-object-to-string';
import type { ThemeState } from '@atlaskit/tokens/theme-state';

export const themeStateObjectToQueryString = (themeState: Partial<ThemeState>): string => {
	const themeString = themeObjectToString(themeState);
	return encodeURIComponent(themeString);
};
